import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomSpinnerRequestHeader } from '@app/custom-service/spinner-interceptor.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { QuickAccess, User } from './home-acesso-rapido.models';
const BASE_PATH = environment.basePath;
const BASE_PATH_EXTERNAL = environment.basePathExternal

@Injectable({
  providedIn: 'root',
})
export class HomeAcessoRapidoService {
  constructor(private http: HttpClient) { }

  getLoggedUser(headers?: CustomSpinnerRequestHeader): Observable<any> {
    if (!headers) headers = new CustomSpinnerRequestHeader(true);
    return this.http.get<any>(
      `${BASE_PATH}/bff/dashboard/shortcut/current_user`,
      { headers: headers }
    );
  }

  getUserSSO(): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post<any>(`${BASE_PATH}/bff/master/loggedProfile`, { headers: headers })
  }
  loginSso(userSso, email,system) {
   // let params = new HttpParams();
   const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
   let lang = localStorage.getItem("s3brazilwebportalfe_locale_id")
   /* if (lang=="pt"){
     lang = "pt-BR"

   } */
   let body ={
     "email" : email,
    // "endpoint": "",
     "expiry": 3600,
     "language": "pt-BR",
     "login": userSso,
     "system": system,
     "typelogin":"3"

   }
  /*   if (userSso) {
      params = params.append('login', userSso.toString());
    }
    if (email) {
      params = params.append('email', email.toString());
    }

    params = params.append('expiry', "3600");
    params = params.append('language', "pt-BR".toString());
    params = params.append('endpoint', "");
    params = params.append('typelogin', "5");
    params = params.append('system', system.toString()); */
    return this.http.post<any>(
      `${BASE_PATH_EXTERNAL}/getLoginSSO`,body, { headers: headers })
  }

  getQuickAccesses(user_id, headers?: CustomSpinnerRequestHeader): Observable<QuickAccess[]> {

    if (!headers) headers = new CustomSpinnerRequestHeader(true, { 'Content-Type': 'application/json' });

    return this.http.post<QuickAccess[]>(
      `${BASE_PATH}/bff/dashboard/shortcut/user`,
      { id: user_id }, { headers: headers }
    );
  }

  deleteQuickAccess(shortcut_id: string): Observable<any> {
    return this.http.delete<any>(
      `${BASE_PATH}/bff/dashboard/shortcut/${shortcut_id}`,
    );
  }
}
